var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.931 2.1C4.389 2.1 2.1 4.5262 2.1 8.2824V19.7176C2.1 23.4738 4.389 25.9 7.931 25.9H20.0662C23.6096 25.9 25.9 23.4738 25.9 19.7176V8.2824C25.9 4.5262 23.6096 2.1 20.0676 2.1H7.931ZM20.0662 28H7.931C3.1864 28 0 24.6708 0 19.7176V8.2824C0 3.3292 3.1864 0 7.931 0H20.0676C24.8122 0 28 3.3292 28 8.2824V19.7176C28 24.6708 24.8122 28 20.0662 28Z",
    fill: "#5DE27B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3381 18.3717C12.0707 18.3717 11.8005 18.2695 11.5961 18.0637L8.27249 14.7415C7.86229 14.3313 7.86229 13.6677 8.27249 13.2575C8.68269 12.8473 9.34629 12.8473 9.75649 13.2575L12.3381 15.8363L18.2405 9.93534C18.6507 9.52514 19.3143 9.52514 19.7245 9.93534C20.1347 10.3455 20.1347 11.0091 19.7245 11.4193L13.0801 18.0637C12.8757 18.2695 12.6069 18.3717 12.3381 18.3717Z",
    fill: "#5DE27B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/tick_square.711d840f3e0777117eb61393eb08381a.svg";
export { ForwardRef as ReactComponent };